module.exports = __webpack_public_path__ + "static/Scheme-e3kit-2db77cb1ceb1dd9b89d2ab8e18525024.png";